<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
  <div class="card-header">
    Attendance
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12 p-1">
        <div class="card" style="height: 25rem;">
          <div class="card-body p-1">
            <div class="row">
              <div class="col-auto">
                <ngb-datepicker #dp [(ngModel)]="filter.AttendanceDate" (navigate)="onNavigate($event)"
                  [dayTemplate]="customDay" (dateSelect)="CalenderDateSelect($event)"></ngb-datepicker>
                <ng-template #customDay ngbdatepickerdayview let-date="date" let-currentMonth="currentMonth"
                  let-selected="selected" let-disabled="disabled">
                  <div class="day-container" style="text-align: center;
                          width: 2rem;
                          height: 2rem;
                          line-height: 2rem;
                          border-radius: .25rem;
                          background: transparent;">
                    <span class="custom-day" [class.faded]="date.month !== currentMonth" [class.selected]="selected"
                      [class.disabled]="disabled" [ngStyle]="getDayStyle(date)">
                      {{ date.day }}
                    </span>
                    <div class="dot" [ngStyle]="getDayDotStyle(date)"></div>
                    <!-- New dot element -->
                  </div>
                </ng-template>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-md-7">
                    <div class="row" style="align-items: center;line-height: normal;">
                      <div class="col-3">
                        <img *ngIf="CalendarDetailsData.Photo != null && CalendarDetailsData.Photo != ''" mat-card-image
                          class="userImage" [src]="common.PhotoLink(CalendarDetailsData.Photo)" />
                        <div *ngIf="CalendarDetailsData.Photo == null || CalendarDetailsData.Photo == ''"
                          class="initial-image">
                          <div class="image">
                            {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                          </div>
                        </div>
                      </div>
                      <div class="col-9 userdetail">
                        <label class="form-label"
                          style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{CalendarDetailsData.EmployeeName}}</label><br />
                        <label class="form-label"
                          style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{CalendarDetailsData.EmpCode}}</label><br />
                        <label class="form-label"
                          style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{CalendarDetailsData.DesignationName}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col"></div>
                  <div class="col-md-4">
                    <label for="RequestDate" class="text-label-light">Attendance Date</label> <br />
                    <label name="RequestDate" class="text-label-dark">{{CalendarDetailsData.AttendanceDate!=
                      null?this.dateFromat.format(CalendarDetailsData.AttendanceDate):''}}</label>
                  </div>
                </div>
                <div style="background-color:#0078d42e;border-radius: 5px;" class="p-1 mb-2">
                  <div class="row align-items-center mx-2">
                    <div class="col-md-5">
                      <div class="row align-items-center">
                        <div class="col-3">
                          <img
                            *ngIf="CalendarDetailsData.DailyAttendancePhoto != null && CalendarDetailsData.DailyAttendancePhoto != ''"
                            mat-card-image class="userImage" [src]="CalendarDetailsData.DailyAttendancePhoto"
                            (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhoto,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                          <div
                            *ngIf="CalendarDetailsData.DailyAttendancePhoto == null || CalendarDetailsData.DailyAttendancePhoto == ''"
                            class="initial-image">
                            <div class="image">
                              {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <label for="InTime" class="text-label-light">In Time</label> <br />
                          <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                            *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime | date : 'dd MMM
                            yyyy'}}</label>
                          <br />
                          <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                            *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime | date :
                            'HH:mm:ss'}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="row align-items-center">
                        <div class="col-3">
                          <img
                            *ngIf="CalendarDetailsData.DailyAttendancePhotoOut != null && CalendarDetailsData.DailyAttendancePhotoOut != ''"
                            mat-card-image class="userImage" [src]="CalendarDetailsData.DailyAttendancePhotoOut"
                            (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhotoOut,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                          <div
                            *ngIf="CalendarDetailsData.DailyAttendancePhotoOut == null || CalendarDetailsData.DailyAttendancePhotoOut == ''"
                            class="initial-image">
                            <div class="image">
                              {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <label for="OutTime" class="text-label-light">Out Time</label> <br />
                          <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                            *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime | date : 'dd MMM
                            yyyy'}}</label>
                          <br />
                          <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                            *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime | date :
                            'HH:mm:ss'}}</label>

                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div
                        *ngIf="calculateTotalDuration(CalendarDetailsData.InTime | date : 'HH:mm:ss', CalendarDetailsData.OutTime | date : 'HH:mm:ss') !== ''"
                        style="background: linear-gradient(to right, #338AF3, #4B65DF); color: white; border-radius: 10px;"
                        class="mt-2;">
                        <div>
                          <p class="pt-2" style="font-weight: bold; text-align: center; margin:auto">
                            {{calculateTotalDuration(CalendarDetailsData.InTime | date : 'HH:mm:ss',
                            CalendarDetailsData.OutTime | date : 'HH:mm:ss') }}
                          </p>
                        </div>
                        <div>
                          <p class="pb-2" style="font-size: 0.8rem; text-align: center; margin:auto">Total Hours</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12"
                      *ngIf="CalendarDetailsData.InTime == null && CalendarDetailsData.OutTime == null"
                      style="text-align: -webkit-center">
                      <label class="text-label-light" style="font-weight: 500;">Attendance Not Punch</label>
                    </div>
                  </div>
                </div>

                <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.DesignationName}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.ShiftTitle}}</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                        Reason</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.InReason}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                        Reason</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.OutReason}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Type</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.AttendanceDescription}}</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Remark</label>
                    </div>
                    <div class="col-md-9">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.Remark}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto" *ngFor="let cDSummary of calendarDataSummary;let i=index">
                <span class="badge success" [ngStyle]="{'background-color': cDSummary.Colour}">{{cDSummary.Type}}
                  ({{cDSummary.Count}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col">
        <div class="row">
        </div>
        <div class="row">
        </div>
      </div>
      <div class="col-auto">
        <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close()">
          <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
          {{!isDisabled?'Cancel':'Loading...'}}
        </button>
      </div>
    </div>
  </div>
</div>